import axiosInstance from '../lib/axios';

export const fetchModelCapabilityMaps = async ({ queryKey }) => {
    const [_key, { industry, page = 1, limit = 12, includeInactive = false }] = queryKey;
    const response = await axiosInstance.get('/admin/capability-maps', {
        params: { 
            industry: industry !== 'all' ? industry : undefined, 
            page, 
            limit,
            includeInactive
        }
    });
    return response.data;
};

export const fetchModelCapabilityMapById = async (id) => {
    const response = await axiosInstance.get(`/admin/capability-maps/${id}`);
    return response.data;
};

export const fetchPhasesByCapabilityMapId = async (capabilityMapId) => {
    const response = await axiosInstance.get(`/admin/capability-maps/${capabilityMapId}/phases`);
    return response.data;
};

export const fetchItemsByPhaseId = async (phaseId) => {
    const response = await axiosInstance.get(`/admin/phases/${phaseId}/items`);
    return response.data;
};

export const createModelCapabilityMap = async (capabilityMapData) => {
    try {
        const response = await axiosInstance.post('/admin/capability-maps', capabilityMapData);
        return response.data;
    } catch (error) {
        console.error('Error creating capability map:', error);
        throw error;
    }
};

export const updateModelCapabilityMap = async (id, capabilityMapData) => {
    try {
        const response = await axiosInstance.put(`/admin/capability-maps/${id}`, capabilityMapData);
        return response.data;
    } catch (error) {
        console.error('Error updating capability map:', error);
        throw error;
    }
};
export const deleteModelCapabilityMap = async (id) => {
    try {
        const response = await axiosInstance.delete(`/admin/capability-maps/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting capability map:', error);
        throw error;
    }
};
export const toggleCapabilityMapVisibility = async (id) => {
    try {
        const response = await axiosInstance.patch(`/admin/capability-maps/${id}/toggle-visibility`);
        return response.data;
    } catch (error) {
        console.error('Error toggling capability map visibility:', error);
        throw error;
    }
};
export const duplicateModelCapabilityMap = async (id, newName) => {
    try {
        const response = await axiosInstance.post(`/admin/capability-maps/${id}/duplicate`, { newName });
        return response.data;
    } catch (error) {
        console.error('Error duplicating capability map:', error);
        throw error;
    }
};

export const fetchIndustries = async () => {
    const response = await axiosInstance.get('/admin/allIndustries');
    return response.data;
};